import { NgControl } from '@angular/forms';
import { Directive, Input, inject } from '@angular/core';

@Directive({
    // eslint-disable-next-line @angular-eslint/directive-selector
    selector: '[disableControl]',
    standalone: false
})
export class DisableControlDirective {
    private ngControl = inject(NgControl);

    @Input() set disableControl(condition: boolean) {
        const action = condition ? 'disable' : 'enable';
        if (this.ngControl.control) {
            this.ngControl.control[action]();
        }
    }
}
